module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "conversations-visitor-ui": "static-1.25719",
      "ably": "static-2.2",
      "conversations-async-data": "static-2.6351",
      "conversations-error-reporting": "static-1.7629",
      "conversations-internal-pub-sub": "static-1.14688",
      "conversations-internal-schema": "static-1.11335",
      "conversations-message-history": "static-1.9776",
      "conversations-test-sdk": "static-1.9168",
      "conversations-visitor-experience-components": "static-1.19082",
      "head-dlb": "static-1.3911",
      "hs-promise-utils": "static-1.4208",
      "hs-test-utils": "static-1.6672",
      "hubspot-dlb": "static-2.1371",
      "HubStyleTokens": "static-2.10179",
      "I18n": "static-7.1380",
      "jasmine-immutable": "static-1.1649",
      "jasmine-runner": "static-1.5087",
      "quartz": "static-1.5434",
      "react-aria": "static-1.38",
      "react-dlb": "static-1.51",
      "react-transition-group": "static-2.8",
      "redux-thunk": "static-2.43",
      "transmute": "static-2.29",
      "urlinator": "static-1.3234",
      "viral-links-lib": "static-1.5560",
      "visitor-ui-component-library": "static-1.4872",
      "webpack-env": "static-1.54",
      "ably-hubspot-js": "static-2.3267",
      "atom": "static-1.3909",
      "autolinker": "static-3.11",
      "classnames": "static-2.10",
      "conversations-http": "static-1.3487",
      "conversations-infrastructure": "static-1.7615",
      "conversations-prop-types": "static-1.6105",
      "conversations-visibility-tools": "static-1.4436",
      "conversations-visitor-message-history": "static-1.17819",
      "cssUtils": "static-1.469",
      "enviro": "static-4.300",
      "flux-actions": "static-1.268",
      "hs-lodash": "static-4.45",
      "hub-http": "static-1.4807",
      "hubspot-url-utils": "static-1.3028",
      "immer": "static-1.33",
      "immutable": "static-2.19",
      "metrics-js": "static-1.8417",
      "PatternValidationJS": "static-1.437",
      "PortalIdParser": "static-2.278",
      "raven": "static-3.4646",
      "react": "static-7.151",
      "react-dom": "static-7.85",
      "react-redux": "static-7.16",
      "react-rhumb": "static-1.15269",
      "react-select-plus": "static-1.65",
      "react-utils": "static-2.4219",
      "redux": "static-4.16",
      "redux-toolkit": "static-1.7",
      "reselect": "static-2.16",
      "sanitize": "static-1.3068",
      "sanitize-text": "static-1.6863",
      "signup-constants": "static-1.15966",
      "styled-components": "static-2.63",
      "StyleGuideUI": "static-3.455",
      "usage-tracker": "static-1.6146",
      "usage-tracker-core": "static-1.5996",
      "usage-tracker-multi": "static-1.4560",
      "usage-tracker-public": "static-1.5957",
      "visitor-ui-component-library-icons": "static-1.4683",
      "hs-promise-rejection-tracking": "static-1.4190",
      "raven-hubspot": "static-1.4953",
      "hoist-non-react-statics": "static-3.9",
      "bend-plugin-trellis-migration": "static-1.2345",
      "moment": "static-3.26",
      "quartz-core": "static-1.4653",
      "react-immutable-proptypes": "static-2.8",
      "foundations-assets": "static-1.3595",
      "foundations-components": "static-1.5858",
      "foundations-theming": "static-1.2997",
      "UIComponents": "static-3.7127",
      "conversations-skeleton-state": "static-1.6066",
      "cv-backend-services": "static-1.1110",
      "icons": "static-2.591",
      "react-input-autosize": "static-2.17",
      "ui-images": "static-2.809",
      "permission-components": "static-1.4045",
      "react-virtualized": "static-2.73",
      "HeadJS": "static-2.567",
      "framer-motion": "static-1.40",
      "hs-test-utils-bend-plugin": "static-1.1783",
      "msw": "static-1.39",
      "testing-library": "static-1.120",
      "i18n-data": "static-1.196",
      "moment-timezone": "static-5.51",
      "jasmine": "static-4.3023",
      "quartz-core-utils": "static-1.2301",
      "signup-ui-url-generator": "static-2.6729",
      "HubStyle": "static-2.10488",
      "sassPrefix": "static-1.130",
      "csstype": "static-1.38",
      "history": "static-4.47",
      "usage-tracker-anonymous": "static-1.4563",
      "copilot-toolkit": "static-1.5796",
      "dispatcher": "static-1.111",
      "general-store": "static-6.20",
      "hub-http-janus": "static-1.639",
      "hub-http-shared-msw-handlers": "static-1.6922",
      "hubspotter-http": "static-1.3483",
      "hubspotter-http-shared-msw-handlers": "static-1.6920",
      "mobile-manifest-mixins": "static-1.338",
      "platform-navigation-bootstrap": "static-1.11092",
      "quick-fetch": "static-1.2772",
      "react-router-dom": "static-5.26",
      "ui-fonts": "static-1.331",
      "hs-story-utils": "static-1.8077",
      "bend-plugin-foundations-components": "static-1.2126",
      "floating-ui": "static-1.28",
      "foundations-theming-specialty": "static-1.714",
      "tanstack-table": "static-1.23",
      "bend-plugin-foundations-theming": "static-1.1480",
      "foundations-theming-base": "static-1.1982",
      "rpc-client-utils": "static-1.3401",
      "ts-schema": "static-1.3030",
      "chatspot-client-types": "static-1.8360",
      "chatspot-core": "static-1.14995",
      "platform-infra-nav-components": "static-1.6588"
    },
    "depPathPrefixes": {
      "conversations-visitor-ui": "/conversations-visitor-ui/static-1.25719",
      "ably": "/ably/static-2.2",
      "conversations-async-data": "/conversations-async-data/static-2.6351",
      "conversations-error-reporting": "/conversations-error-reporting/static-1.7629",
      "conversations-internal-pub-sub": "/conversations-internal-pub-sub/static-1.14688",
      "conversations-internal-schema": "/conversations-internal-schema/static-1.11335",
      "conversations-message-history": "/conversations-message-history/static-1.9776",
      "conversations-test-sdk": "/conversations-test-sdk/static-1.9168",
      "conversations-visitor-experience-components": "/conversations-visitor-experience-components/static-1.19082",
      "head-dlb": "/head-dlb/static-1.3911",
      "hs-promise-utils": "/hs-promise-utils/static-1.4208",
      "hs-test-utils": "/hs-test-utils/static-1.6672",
      "hubspot-dlb": "/hubspot-dlb/static-2.1371",
      "HubStyleTokens": "/HubStyleTokens/static-2.10179",
      "I18n": "/I18n/static-7.1380",
      "jasmine-immutable": "/jasmine-immutable/static-1.1649",
      "jasmine-runner": "/jasmine-runner/static-1.5087",
      "quartz": "/quartz/static-1.5434",
      "react-aria": "/react-aria/static-1.38",
      "react-dlb": "/react-dlb/static-1.51",
      "react-transition-group": "/react-transition-group/static-2.8",
      "redux-thunk": "/redux-thunk/static-2.43",
      "transmute": "/transmute/static-2.29",
      "urlinator": "/urlinator/static-1.3234",
      "viral-links-lib": "/viral-links-lib/static-1.5560",
      "visitor-ui-component-library": "/visitor-ui-component-library/static-1.4872",
      "webpack-env": "/webpack-env/static-1.54",
      "ably-hubspot-js": "/ably-hubspot-js/static-2.3267",
      "atom": "/atom/static-1.3909",
      "autolinker": "/autolinker/static-3.11",
      "classnames": "/classnames/static-2.10",
      "conversations-http": "/conversations-http/static-1.3487",
      "conversations-infrastructure": "/conversations-infrastructure/static-1.7615",
      "conversations-prop-types": "/conversations-prop-types/static-1.6105",
      "conversations-visibility-tools": "/conversations-visibility-tools/static-1.4436",
      "conversations-visitor-message-history": "/conversations-visitor-message-history/static-1.17819",
      "cssUtils": "/cssUtils/static-1.469",
      "enviro": "/enviro/static-4.300",
      "flux-actions": "/flux-actions/static-1.268",
      "hs-lodash": "/hs-lodash/static-4.45",
      "hub-http": "/hub-http/static-1.4807",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.3028",
      "immer": "/immer/static-1.33",
      "immutable": "/immutable/static-2.19",
      "metrics-js": "/metrics-js/static-1.8417",
      "PatternValidationJS": "/PatternValidationJS/static-1.437",
      "PortalIdParser": "/PortalIdParser/static-2.278",
      "raven": "/raven/static-3.4646",
      "react": "/react/static-7.151",
      "react-dom": "/react-dom/static-7.85",
      "react-redux": "/react-redux/static-7.16",
      "react-rhumb": "/react-rhumb/static-1.15269",
      "react-select-plus": "/react-select-plus/static-1.65",
      "react-utils": "/react-utils/static-2.4219",
      "redux": "/redux/static-4.16",
      "redux-toolkit": "/redux-toolkit/static-1.7",
      "reselect": "/reselect/static-2.16",
      "sanitize": "/sanitize/static-1.3068",
      "sanitize-text": "/sanitize-text/static-1.6863",
      "signup-constants": "/signup-constants/static-1.15966",
      "styled-components": "/styled-components/static-2.63",
      "StyleGuideUI": "/StyleGuideUI/static-3.455",
      "usage-tracker": "/usage-tracker/static-1.6146",
      "usage-tracker-core": "/usage-tracker-core/static-1.5996",
      "usage-tracker-multi": "/usage-tracker-multi/static-1.4560",
      "usage-tracker-public": "/usage-tracker-public/static-1.5957",
      "visitor-ui-component-library-icons": "/visitor-ui-component-library-icons/static-1.4683",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.4190",
      "raven-hubspot": "/raven-hubspot/static-1.4953",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.2345",
      "moment": "/moment/static-3.26",
      "quartz-core": "/quartz-core/static-1.4653",
      "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
      "foundations-assets": "/foundations-assets/static-1.3595",
      "foundations-components": "/foundations-components/static-1.5858",
      "foundations-theming": "/foundations-theming/static-1.2997",
      "UIComponents": "/UIComponents/static-3.7127",
      "conversations-skeleton-state": "/conversations-skeleton-state/static-1.6066",
      "cv-backend-services": "/cv-backend-services/static-1.1110",
      "icons": "/icons/static-2.591",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "ui-images": "/ui-images/static-2.809",
      "permission-components": "/permission-components/static-1.4045",
      "react-virtualized": "/react-virtualized/static-2.73",
      "HeadJS": "/HeadJS/static-2.567",
      "framer-motion": "/framer-motion/static-1.40",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.1783",
      "msw": "/msw/static-1.39",
      "testing-library": "/testing-library/static-1.120",
      "i18n-data": "/i18n-data/static-1.196",
      "moment-timezone": "/moment-timezone/static-5.51",
      "jasmine": "/jasmine/static-4.3023",
      "quartz-core-utils": "/quartz-core-utils/static-1.2301",
      "signup-ui-url-generator": "/signup-ui-url-generator/static-2.6729",
      "HubStyle": "/HubStyle/static-2.10488",
      "sassPrefix": "/sassPrefix/static-1.130",
      "csstype": "/csstype/static-1.38",
      "history": "/history/static-4.47",
      "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.4563",
      "copilot-toolkit": "/copilot-toolkit/static-1.5796",
      "dispatcher": "/dispatcher/static-1.111",
      "general-store": "/general-store/static-6.20",
      "hub-http-janus": "/hub-http-janus/static-1.639",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.6922",
      "hubspotter-http": "/hubspotter-http/static-1.3483",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.6920",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.338",
      "platform-navigation-bootstrap": "/platform-navigation-bootstrap/static-1.11092",
      "quick-fetch": "/quick-fetch/static-1.2772",
      "react-router-dom": "/react-router-dom/static-5.26",
      "ui-fonts": "/ui-fonts/static-1.331",
      "hs-story-utils": "/hs-story-utils/static-1.8077",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.2126",
      "floating-ui": "/floating-ui/static-1.28",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.714",
      "tanstack-table": "/tanstack-table/static-1.23",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.1480",
      "foundations-theming-base": "/foundations-theming-base/static-1.1982",
      "rpc-client-utils": "/rpc-client-utils/static-1.3401",
      "ts-schema": "/ts-schema/static-1.3030",
      "chatspot-client-types": "/chatspot-client-types/static-1.8360",
      "chatspot-core": "/chatspot-core/static-1.14995",
      "platform-infra-nav-components": "/platform-infra-nav-components/static-1.6588"
    },
    "project": "conversations-visitor-ui",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};